<template>
  <div
    :class="
      cn(
        [
          'text-neutral-300 bg-neutral-900 py-4 px-5 border border-neutral-300 rounded-md flex gap-4',
        ],
        props.class ?? ''
      )
    "
  >
    <Info />
    <div>
      <div class="text-neutral-400 text-base font-semibold">
        {{ title }}
      </div>
      <div class="text-neutral-400 text-xs">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { Info } from 'lucide-vue-next';
import { cn } from '../../utils.js';

const props = defineProps({
  title: {
    type: String,
    default: 'Upgrade workspace',
  },
  subtitle: {
    type: String,
    default: '',
  },
  class: {
    type: String,
    default: '',
  },
});
</script>
